<template>
	<main class="new-flight-bookings">
		<section class="new-flight-bookings__content">
			<div class="new-flight-bookings__inner new-layout-container">
				<img class="new-flight-bookings__icon" src="/static/buttons/new/flight.svg" alt="">

				<div class="new-flight-bookings__accent"></div>
				<h1>{{content.title}}</h1>

				<div class="new-flight-bookings__intro">
					<p v-for="paragraph in content.intro" :key="paragraph">{{paragraph}}</p>
				</div>

				<div class="new-flight-bookings__items">
					<article
						v-for="item in content.items"
						:key="item.number"
						class="new-flight-bookings__item"
					>
						<span class="new-flight-bookings__number">{{item.number}}</span>
						<h2>{{item.title}}</h2>
						<p>{{item.text}}</p>
					</article>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	computed: {
		content() {
			return translate(this.$store.state.language).staticPages.flightBookings;
		},
	},
};
</script>

<style scoped lang="scss">
.new-flight-bookings {
	background: #ffffff;
	color: #4c4b4b;
}

.new-flight-bookings__content {
	padding: 83px 0 86px;
}

.new-flight-bookings__inner {
	padding: 0;
}

.new-flight-bookings__icon {
	display: block;
	width: 40px;
	height: 40px;
	object-fit: contain;
}

.new-flight-bookings__accent {
	width: 44px;
	height: 4px;
	margin-top: 12px;
	margin-bottom: 18px;
	background: #5da3bd;
}

.new-flight-bookings h1 {
	margin: 0 0 16px;
	color: #4c4b4b;
	font-size: 40px;
	font-weight: 500;
	line-height: 47px;
	letter-spacing: 0;
}

.new-flight-bookings__intro {
	max-width: 1458px;
	color: #4c4b4b;
	font-size: 22px;
	font-weight: 400;
	line-height: 35px;
}

.new-flight-bookings__intro p {
	margin: 0;
}

.new-flight-bookings__intro p + p {
	margin-top: 20px;
}

.new-flight-bookings__items {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 452px));
	justify-content: space-between;
	gap: 48px 42px;
	margin-top: 72px;
}

.new-flight-bookings__item {
	min-width: 0;
	color: #4c4b4b;
}

.new-flight-bookings__number {
	display: block;
	margin-bottom: 10px;
	color: #5da3bd;
	font-size: 80px;
	font-weight: 500;
	line-height: 94px;
}

.new-flight-bookings__item h2 {
	min-height: 70px;
	margin: 0 0 28px;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 500;
	line-height: 35px;
	letter-spacing: 0;
}

.new-flight-bookings__item p {
	margin: 0;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 400;
	line-height: 35px;
}

@media (max-width: 1180px) {
	.new-flight-bookings__items {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 720px) {
	.new-flight-bookings__content {
		padding: 58px 0 72px;
	}

	.new-flight-bookings h1 {
		font-size: 34px;
		line-height: 40px;
	}

	.new-flight-bookings__intro {
		font-size: 18px;
		line-height: 30px;
	}

	.new-flight-bookings__items {
		grid-template-columns: 1fr;
		margin-top: 56px;
	}

	.new-flight-bookings__item h2 {
		min-height: 0;
		margin-bottom: 18px;
	}

	.new-flight-bookings__item p {
		font-size: 18px;
		line-height: 30px;
	}
}

@media (max-width: 420px) {
	.new-flight-bookings__number {
		font-size: 62px;
		line-height: 72px;
	}

	.new-flight-bookings__item h2 {
		font-size: 22px;
		line-height: 30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/flight-bookings/FlightBookings.vue